import React from "react";

export default function About() {
    return (
        <>
            <div id="aboutus_"></div>
            <div id="aboutus">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm" id="abouttitle">
                                О нас
                                </div>
                                <div className="col-sm">
                                <img id="aboutlogo" src="../images/logo2.png"/>    
                                </div>
                            </div>
                            <div id="abouttext">Современные технологии достигли такого уровня, что высококачественный прототип будущего проекта создаёт необходимость включения в производственный план целого ряда внеочередных мероприятий с учётом комплекса новых принципов формирования материально-технической и кадровой базы. Но высококачественный прототип будущего проекта однозначно фиксирует необходимость как самодостаточных, так и внешне зависимых концептуальных решений. Высокий уровень вовлечения представителей целевой аудитории является четким доказательством простого факта: граница обучения кадров предоставляет широкие возможности для позиций, занимаемых участниками в отношении поставленных задач. Кстати,  явные признаки победы институционализации рассмотрены исключительно в разрезе маркетинговых и финансовых предпосылок. Ясность нашей позиции очевидна: глубокий уровень погружения требует от нас анализа прогресса профессионального сообщества.</div>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <img id="aboutpic" src="../images/bank4.png"/>
                    </div>
                </div>
            </div>
        </div>

        <div id="ourspec">
            <div id="ourspectitle">Наши специалисты </div>
            <div className="container-fluid" id="specin">
                <div className="row">
                    <div className="col-sm-4">
                        <img id="specpic"  src="../images/bank4.png"/>
                    </div>
                    <div className="col-sm">
                        <div className="specname">Алексей Милюков Владимирович</div>
                        <div className="specabout">
                            Адвокат с 17-летним стажем<br/>
                            Завершено более 500 дел по банкротству
                        </div>
                        <div className="specminititle">В 2003 году</div>
                        <div className="specabout">
                        окончил Самарский государственный университет по специальности «Юриспруденция»  
                        </div>
                        <div className="specminititle">В 2015 году</div>
                        <div className="specabout">
                        окончил курс переподготовки по специальности «Арбитражный управляющий»
                        </div>
                        <div className="specminititle">Награды</div>
                        <div className="specabout">
                        работа адвоката получила положительный отклик подтвержденный отзывами многочисленных партнеров, а также отмечена Палатой адвокатов и благодарственными письмами депутатов Государственной <a href="#">думы РФ...</a>
                        </div>
                    </div>
                </div>

                    
                </div>
        </div>
        <div className="container-fluid" id="specphoto">
                            <div className="row">
                                <div className="col-sm-4">
                                    <img id="specpic" src="../images/bank4.png" />
                                    <div className="specname specname2">Алексей Милюков Владимирович</div>
                                    <div className="underspecname2">Юрист</div>
                                </div>
                                <div className="col-sm-4">
                                    <img id="specpic" src="../images/bank4.png" />
                                    <div className="specname specname2">Алексей Милюков Владимирович</div>
                                    <div className="underspecname2">Юрист</div>
                                </div>
                                <div className="col-sm-4">
                                    <img id="specpic" src="../images/bank4.png" />
                                    <div className="specname specname2">Алексей Милюков Владимирович</div>
                                    <div className="underspecname2">Юрист</div>
                                </div>
                            </div>
                        </div>
         <div className='fonlogo fonlogo2'><img id='bank2' src='../images/bank2.png' />
            Учитывая ключевые сценарии поведения, высокотехнологичная концепция общественного уклада однозначно фиксирует необходимость новых принципов формирования материально-технической и кадровой базы! Лишь некоторые особенности внутренней политики освещают чрезвычайно интересные особенности картины в целом, однако конкретные выводы, разумеется, подвергнуты целой серии независимых исследований. Непосредственные участники технического прогресса призывают нас к новым свершениям, которые, <span id="details3"><a href="#">в свою очередь,...</a></span></div>

            </>
    )
}